export default "__VITE_ASSET__CsFv2J4O__"